import { Injectable } from '@angular/core';

import { environment } from '../../environments/environment';

import { setDefaultOptions, loadModules } from 'esri-loader';

export let LoadedModules: any = null;
let esriLoaderService: EsriLoadService = null;

@Injectable()
export class EsriLoadService {
  loading: boolean = false;
  waitInterval: any = null;
  constructor() {
    esriLoaderService = this;
}

async loadClass() {
    if(LoadedModules == null && !this.loading){
        this.loading = true;

        setDefaultOptions({ version: '4.34' })
        return loadModules(  [
          "esri/Map",
              "esri/widgets/Expand",
              "esri/views/MapView",
              "esri/rest/route",
              "esri/symbols/PictureMarkerSymbol",
              "esri/Graphic",
              "esri/symbols/SimpleMarkerSymbol",
              "esri/symbols/SimpleLineSymbol",
              "esri/PopupTemplate",
              "esri/geometry/Extent",
              "esri/geometry/Point",
              "esri/widgets/BasemapGallery",
              "esri/Basemap",
              "esri/Color",
              "esri/widgets/Sketch/SketchViewModel",
              "esri/geometry/Polyline",
              "esri/layers/GraphicsLayer",
              "esri/geometry/SpatialReference",
              "esri/rest/support/FeatureSet",
              "esri/config",
              "esri/widgets/Popup",
              "esri/geometry/support/jsonUtils",
              "esri/widgets/Editor",
              "esri/geometry/support/webMercatorUtils",
              "esri/rest/support/PointBarrier",
              "esri/geometry/Polygon",
              "esri/core/reactiveUtils" 
            ])
            .then(([
                _Map,
                _Expand,
                _MapView,
                _RouteTask,
                _PictureMarkerSymbol,
                _graphic,
                _SimpleMarkerSymbol,
                _SimpleLineSymbol,
                _PopupTemplate,
                _Extent,
                _Point,
                _BasemapGallery,
                _Basemap,
                _Color,
                _SketchViewModel,
                _Polyline,
                _GraphicsLayer,
                _SpatialReference,
                _FeatureSet,
                _Config,
                _InfoWindow,
                _JsonUtils,
                _Edit,
                _WebMercatorUtils,
                _PointBarrier,
                _Polygon,
                _reactiveUtils
              ]
            ) => {
              LoadedModules = {
                Map: _Map,
                Expand: _Expand,
                MapView: _MapView,
                RouteTask: _RouteTask,
                PictureMarkerSymbol: _PictureMarkerSymbol,
                Graphic: _graphic,
                SimpleMarkerSymbol: _SimpleMarkerSymbol,
                SimpleLineSymbol: _SimpleLineSymbol,
                PopupTemplate: _PopupTemplate,
                Extent: _Extent,
                Point: _Point,
                BasemapGallery: _BasemapGallery,
                Basemap: _Basemap,
                Color: _Color,
                SketchViewModel: _SketchViewModel,
                Polyline: _Polyline,
                GraphicsLayer: _GraphicsLayer,
                SpatialReference: _SpatialReference,
                FeatureSet: _FeatureSet,
                EsriConfig: _Config,
                InfoWindow: _InfoWindow,
                JsonUtils: _JsonUtils,
                Edit: _Edit,
                WebMercatorUtils: _WebMercatorUtils,
                PointBarrier: _PointBarrier,
                Polygon: _Polygon,
                ReactiveUtils: _reactiveUtils
              }
            });
        }
        else {
      return new Promise((resolve, reject) => {
        esriLoaderService.waitInterval = setInterval(function () {
          if (LoadedModules != null) {
            clearInterval(esriLoaderService.waitInterval);
            resolve(() => { });
          }
        }, 100);
      });
    }
  }
}
